<span class="fm-coordinates">
	<span>{{formattedCoordinates}}</span>
	<b-button @click="copy()" v-b-tooltip.hover="'Copy to clipboard'"><Icon icon="copy" alt="Copy to clipboard"></Icon></b-button>
</span>